"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _translateDOMPositionXY = require("dom-lib/translateDOMPositionXY");

var translateDOMPositionXY = (0, _translateDOMPositionXY.getTranslateDOMPositionXY)({
  enable3DTransform: true
});
var _default = translateDOMPositionXY;
exports["default"] = _default;